import React from 'react'
import { Helmet } from 'react-helmet';

interface Props {
  title: string;
  description?: string;
  lang?: string;
}

const Seo = ({ title, description, lang }: Props) => {

  const seo = {
    lang: lang || 'en',
    title: title || 'Goracle',
    description: description || 'Goracle website',
    twitterHandle: 'Goracle',
    url: 'https://goracle.io',
  };

  return (
    <Helmet titleTemplate={'%s | Goracle'}>
      <html lang={seo.lang} />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="og:type" content="website" />

      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {/* {seo.image && <meta property="og:image" content={seo.image} />} */}

      <meta name="twitter:card" content="summary" />
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {/* {seo.image && <meta name="twitter:image" content={seo.image} />} */}
      {seo.twitterHandle && (
        <meta name="twitter:creator" content={seo.twitterHandle} />
      )}
    </Helmet>
  )
}

export default Seo;
